"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteStorageData = exports.setStorageData = exports.getStorageData = void 0;
/** 从本地存储中获取数据
 * key 必填
 */
var getStorageData = function (key) {
    return new Promise(function (resolve, reject) {
        if (!key || !window.localStorage) {
            reject();
        }
        else {
            var obj = JSON.parse(localStorage.getItem(key) || "{}"), expireTime = obj.expireTime, value = obj.value;
            if (new Date().getTime() >= expireTime || !value) {
                // 失效
                value && exports.deleteStorageData(key);
                reject();
            }
            else {
                resolve(value);
            }
        }
    });
};
exports.getStorageData = getStorageData;
/** 往本地存储数据
 * key    必填
 * value  必填
 * expire 选填 失效天数
 */
var setStorageData = function (_a) {
    var _b = _a === void 0 ? {} : _a, key = _b.key, value = _b.value, _c = _b.expire, expire = _c === void 0 ? 1 : _c;
    if (!key || !value) {
        return false;
    }
    var exdate = new Date(), obj;
    exdate.setDate(exdate.getDate() + expire);
    obj = { expireTime: exdate.getTime(), value: value };
    localStorage.setItem(key, JSON.stringify(obj));
};
exports.setStorageData = setStorageData;
/**
 * 从本地存储中删除数据
 * key 必填
 */
var deleteStorageData = function (key) {
    if (!key) {
        return false;
    }
    localStorage.removeItem(key);
};
exports.deleteStorageData = deleteStorageData;
